import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const MoreDetails = () => {
  return (
    <section className="relative w-full flex flex-col items-center justify-center text-white py-20 md:py-40 overflow-hidden">
      <div className="relative z-10 flex flex-col items-center">
        <motion.h2
          initial="hidden"
          animate="visible"
          variants={fadeIn}
          className="text-3xl md:text-5xl font-orbitron font-bold text-center text-white"
        >
          WANT MORE DETAILS?
        </motion.h2>

        <motion.p
          initial="hidden"
          animate="visible"
          variants={fadeIn}
          transition={{ delay: 0.3 }}
          className="text-gray-400 text-center mt-2"
        >
          We always got you covered!
        </motion.p>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeIn}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link
            to="/whitepaper"
            className="mt-10 inline-block px-10 py-3 text-lg font-bold text-white no-underline bg-orange-500 hover:bg-white hover:text-black rounded-full transition-all duration-300"
          >
            Read Whitepaper Here
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default MoreDetails;
